import React from 'react';
import { styled } from 'styled-components';

export const ContinueWith = () => (
  <Container>
    <span>OR CONTINUE WITH</span>
    <div />
  </Container>
);

const Container = styled.div`
  max-width: 596px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 36px auto 0;
  width: 100%;

  & > div {
    position: absolute;
    top: 6px;
    left: 0;
    right: 0;
    border-top: 1px dashed #d2cece;
    z-index: 1;
  }

  span {
    position: relative;
    display: block;
    color: ${({ theme }) => theme.colors.darkBlue};
    background-color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
    padding: 0 10px;
    z-index: 2;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    max-width: 335px;
  }
`;
